<template>
  <div class=" right-0 overflow-y-auto border-l-2 border-gray-100 bg-gray-50">
    <!-- organisation section start -->
    <h5 class="font-semibold text-gray-700 p-2 ">General Info</h5>
    <div class="border-2 py-2 px-3 mx-2 " style="background-color:#f3f6f9 ;">
      <h5>Personal Detail</h5>
      <div class="flex flex-col justify-between space-y-4">
        <div class="flex flex-col overflow-auto flex-grow space-y-3">
          <div class="gap-2 items-center text-xs p-2 rounded-xl bg-white">
            <div class="flex justify-between px-2">
              <div>
                <img class="rounded-full w-7" src="https://randomuser.me/api/portraits/med/men/75.jpg" alt="" />
              </div>
              <div class="bg-red-100 px-2 py-1">
                <p class="text-xs text-gray-500 text-red-700">Responded</p>
              </div>
            </div>
            <div class="mt-3">
              <h6 class=" text-sm font-semibold"v-if="receivedValue.name!=null && receivedValue.participant_2_phone_no||receivedValue.wa_phone_number">
                {{ receivedValue.name}}{{ receivedValue.participant_2_id}}{{ receivedValue.wa_phone_number}}</h6>
              

              <h6 v-else-if="receivedValue.participant_2_phone_no" >
              {{ receivedValue.participant_2_phone_no }}<br>
              <div class="newcontact cursor-pointer text-blue-500 text-xs font-bold" @click="openModal" >create new contact</div>
            </h6>
            <h6 v-else>
              {{ receivedValue }}
            </h6>  
            </div>
          </div>

          <div class="  mt-3">
            <h6 class=" text-sm font-semibold">Email</h6>
            <p class="text-sm text-gray-500">tarun@aruvaa.com</p>
          </div>
          <div class="  mt-3">
            <h6 class="text-sm font-semibold">Date Created</h6>
            <p class="text-xs text-gray-500">Dec 9, 2023, 11:42 AM</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isModalVisible" class="fixed inset-2 flex items-center justify-center bg-gray-500 bg-opacity-50 ">
      <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-xl">
        <h2 class="text-xl font-semibold mb-4">Create New Contact</h2>
        <form @submit.prevent="saveContact">
          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700">Enter Name</label>
            <input v-model="newContact.name" type="text" class="mt-1 p-2 w-full border rounded-md" required />
          </div>
          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700">Enter Phone No.</label>
            <input v-model="receivedValue.participant_2_phone_no" type="text" class="mt-1 p-2 w-full border rounded-md" />
          </div>
          <div class="flex justify-end">
            <button type="button" @click="closeModal" class="bg-gray-400 text-white px-4 py-2 rounded-md mr-2">Cancel</button>
            <button type="submit" class="bg-blue-600 text-white px-4 py-2 rounded-md">Save</button>
          </div>
        </form>
      </div>
    </div>
    <!-- Modal -->

    <!-- Activity Start From Here -->
  
    <!-- test end -->
  </div>
</template>
  
<script>
import NavBar from "@/Layouts/NavBar.vue";
import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink.vue";
import JetSideLink from "@/Jetstream/SideLink.vue";
import JetDropdown from "@/Jetstream/Dropdown.vue";
import JetDropdownLink from "@/Jetstream/DropdownLink.vue";

export default {
  props: {
    selectedId: String,
    selectedType: String,
    receivedValue: {
    type: Object,
    required: false, // or true if you expect it to always be passed
    default: () => ({}) 
  },
    receivedValue:{
      type:String,
      required:false,
      default: () => ({}) 
    },
  },
  components: {
    NavBar,
    JetResponsiveNavLink,
    JetSideLink,
    JetDropdown,
    JetDropdownLink
  },
  data() {
    return {
      isModalVisible: false,
      newContact: {
        name: ''
      }
    };
  },

  methods: {
    openModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    saveContact() {
      // Combine both name and phone number
      const contactToSave = {
        name: this.newContact.name,
        phone_no: this.receivedValue.participant_2_phone_no
      };

      // Log the new contact details (for demonstration, replace this with an API call)
      console.log("New contact saved:", contactToSave);

      // Close modal after saving
      this.closeModal();

      // You can replace this part with an actual API call to save the contact
      axios.post('/all/conversation/storecontacts', contactToSave)
           .then(response => {
               // Handle success
           })
           .catch(error => {
               // Handle error
           });

           this.$emit('contactsaved') 
    }

  },


  mounted() {
console.log(this.receivedValue.wa_phone_number);
  }
}
</script>
  
<style>
/* .right_box {
  height: 95vh !important;
} */

p {
  margin-bottom: 0.01em;
}
.sticky{
  position: sticky; /* Make the div sticky */
    top: 0; /* Stick to the top of the viewport */
    z-index: 1000; /* Optional: Ensure it stays above other content */
}

</style>